import { User01 } from "@untitled-ui/icons-react";
import classNames from "classnames";

import ImageWithFallback from "@/components/media/ImageWithFallback";

import { type Conversation } from "../../types";
import ConversationUserImage from "./ConversationUserImage";

const sizes = {
  md: "size-10",
  lg: "size-12",
};

const iconSizes = {
  md: "size-6",
  lg: "size-7",
};

export default function ConversationImage({
  conversation,
  size = "md",
}: {
  conversation: Conversation<true, true, true>;
  size?: keyof typeof sizes;
}) {
  return conversation.type === "private" ? (
    <ConversationUserImage user={conversation.user} size={size} />
  ) : (
    <div className={classNames("relative inline-block shrink-0", sizes[size])}>
      <div className={classNames("relative rounded-full", sizes[size])}>
        <ImageWithFallback
          src={conversation.group?.image_thumb}
          alt="group image"
          tabIndex={0}
          className={classNames(
            "focus:ring-primary-100 rounded-full object-cover focus:ring-4 focus:outline-hidden",
            sizes[size],
          )}
          fallback={
            <div
              tabIndex={0}
              className={classNames(
                "focus:ring-primary-100 flex items-center justify-center rounded-full bg-gray-100 text-gray-600 focus:ring-4 focus:outline-hidden",
                sizes[size],
              )}
            >
              <User01
                className={classNames("text-gray-600", iconSizes[size])}
              />
            </div>
          }
        />
      </div>
    </div>
  );
}
